import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import ScrollContainer from "react-indiana-drag-scroll";
import { FixedSizeList as List } from "react-window";
import { getCssVar, setCssVar } from "@base/css";
import AutoSizer from "react-virtualized-auto-sizer";
import Midia from "@components/Midia";

import "./Playlist.less";

class Playlist extends PureComponent {
  static propTypes = {
    scroll: PropTypes.bool.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    titulo: PropTypes.string.isRequired,
    videos: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired,
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
      })
    ).isRequired,
  };

  constructor(props) {
    super(props);
    this.renderVideo = this.renderVideo.bind(this);

    window.getVideoIndexById = (id) => {
      let _index = 0;
      props.videos.some((video, index) => {
        if (video.id === id) {
          _index = index;
          return true; // break
        } else {
          return false; // continue
        }
      });
      return _index;
    };
  }

  render() {
    if (this.props.videos.length === 0) return null;
    return (
      <div className="Playlist-component">
        {this.renderHeader()}
        {this.props.scroll ? (
          <ScrollContainer className="videos" vertical={false}>
            {this.renderVideos()}
          </ScrollContainer>
        ) : (
          <AutoSizer>
            {({ height, width }) => (
              <List
                className="videos"
                height={
                  height - parseInt(getCssVar("--playlist-header-height"))
                }
                itemCount={this.props.videos.length}
                itemSize={parseInt(getCssVar("--playlist-height"))}
                width={width}
              >
                {this.renderVideo}
              </List>
            )}
          </AutoSizer>
        )}
      </div>
    );
  }

  renderHeader() {
    return (
      <div
        className="playlist-header"
        ref={(ref) => {
          if (ref) {
            setCssVar("--playlist-header-height", `${ref.offsetHeight}px`);
          }
        }}
      >
        {this.props.scroll ? (
          // Home
          <>
            <Link className="titulo" to={this.getLink()}>
              {this.props.titulo}
            </Link>
            <Link className="botao" to={this.getLink()}>
              <button type="button">Veja +</button>
            </Link>
          </>
        ) : (
          // Veja mais
          <>
            <span className="titulo">{this.props.titulo}</span>
            <Link className="botao" to="/">
              <button type="button">‹ Voltar</button>
            </Link>
          </>
        )}
      </div>
    );
  }

  renderVideo(props) {
    const video = this.props.videos[props.index];
    const videoProps = {
      ...props,
      id: video.id,
      idPlaylist: this.props.id,
      imagem: video.image,
      titulo: video.title,
    };
    if (this.props.scroll) {
      // Home
      videoProps.url = this.getLink(video.id);
    } else {
      // Veja mais
      videoProps.url = video.url;
      videoProps.play = true;
    }
    return <Midia key={video.id} {...videoProps} />;
  }

  renderVideos() {
    return this.props.videos.map((video, index) => this.renderVideo({ index }));
  }

  getLink(scroll) {
    let link = `/playlist/${this.props.id}`;
    if (scroll) link += `?scroll=${scroll}`;
    return link;
  }
}

export default Playlist;
